const STORAGE_CONSTANTS = {
  AUTHENTICATED_USER: 'authenticatedUser',
}

export { STORAGE_CONSTANTS }
